if (!window.myutsuCartOffersInitialized) {
  window.myutsuCartOffersInitialized = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-myutsu-add-upsell]');
    if (!button || button.disabled) return;

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Ajout...';

    try {
      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : [];
      const body = {
        id: Number(variantId),
        quantity: 1,
      };

      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });

      const parsedState = await response.json();
      if (!response.ok) throw new Error(parsedState.description || 'Erreur panier');

      if (cartDrawer && parsedState.sections) {
        cartDrawer.renderContents(parsedState);
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = originalText;
    }
  });
}
